import { bareIzteachClient } from '../clients';
import { retryColdStart } from '../core/coldStart';
import { getDefaultVendorId } from '../environment';
import { encodePassword } from '../password';
import { izteachSession } from '../session';
import type { IzteachTeacherSignInResult } from '../types';

export const IzteachAuthRepository = {
  signInTeacher: (email: string, password: string, vendorId = getDefaultVendorId()) =>
    bareIzteachClient('teacher')
      .post('/teacher/signin', { email, password: encodePassword(password), vendorId })
      .then((res) => res.data as IzteachTeacherSignInResult),

  // SSO: the QLT jwt buys an IZ teacher session (izteach-admin-service). Errors come back as HTTP 500 with the code in the body.
  signInTeacherWithQlt: (token: string, vendorId = getDefaultVendorId()) =>
    retryColdStart(() =>
      bareIzteachClient('teacher')
        .post('/teacher/qlt-signin', { vendorId, token })
        .then((res) => res.data as IzteachTeacherSignInResult),
    ),

  refreshTeacher: (id: string, refreshToken: string, vendorId = izteachSession.vendorId) =>
    bareIzteachClient('teacher')
      .get(`/teacher/refresh/${id}`, {
        params: { refreshToken, vendorId },
        headers: izteachSession.accessToken
          ? { Authorization: izteachSession.accessToken }
          : undefined,
      })
      .then((res) => res.data as IzteachTeacherSignInResult),
};

export default IzteachAuthRepository;
